import SecureRequest from "utils/securerequest";

export interface FeatureFeedbackCreateInput {
  featureType: string;
  featureName: string;
  featureVersion: string;
  score: number;
  feedback: string | null;
  entityType: string;
  entityId: number | string;
  requestId: string;
  clientId?: number | string;
}

export interface ActionLogCreateInput {
  actionTaken: string;
  entityType: string;
  entityId: number | string;
  generatedCopy: string;
  submittedCopy: string;
  userId?: number | string;
  clientId?: number | string;
}

export async function getDisplayFeedbackDialog() {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get('/v3/feedback/gate');
}

export async function submitFeatureFeedback(userId: string | number, feedbackData: FeatureFeedbackCreateInput) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.post(`/v3/feedback/${userId}`, feedbackData);
}

export async function logFeatureAction(actionData: ActionLogCreateInput) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.post(`/v3/feedback/action`, actionData);
}
